import { css } from '@emotion/react';
import { Breadcrumbs, Stack, styled, Typography } from '@mui/material';

import { RouterLink } from '@/components/router/RouterLink';

const StyledRouterLink = styled(RouterLink)(
  ({ theme }) => css`
    color: ${theme.palette.text.primary};
    text-decoration: none;
    font-weight: 500;
    font-size: ${theme.spacing(1.5)};

    &:hover {
      text-decoration: underline;
    }
  `,
);

interface BreadcrumbsNavProps {
  breadcrumbs: { title: string; pathname: string }[];
}

export function BreadcrumbsNav({ breadcrumbs }: BreadcrumbsNavProps) {
  return (
    <Stack alignItems="center" direction="row">
      <Breadcrumbs aria-label="breadcrumbs" color="textPrimary" separator="/">
        {breadcrumbs.map((breadcrumb, index) =>
          index === breadcrumbs.length - 1 ? (
            <Typography
              key={breadcrumb.pathname}
              color="primary"
              display="inline-block"
              sx={{ fontWeight: 500, fontSize: 12 }}
            >
              {breadcrumb.title}
            </Typography>
          ) : (
            <StyledRouterLink key={breadcrumb.pathname} color="neutral" to={breadcrumb.pathname} underline="hover">
              {breadcrumb.title}
            </StyledRouterLink>
          ),
        )}
      </Breadcrumbs>
    </Stack>
  );
}
